var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "star",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.664,
    height: 41.464,
    viewBox: "0 0 49.664 41.464",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M13.842,116.368l2.977-9.22L9,101.42l9.684-.021,3.029-9.2,3.008,9.2,9.684.041-7.819,5.707,2.957,9.22-7.84-5.7Z",
    transform: "translate(-9 -87.698)",
    fill: "#ffde06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M314.791,363.08l3.276,1.329,2.266-2.709-.237,3.523,3.266,1.329-3.42.865-.258,3.482-1.875-2.967-3.41.824,2.246-2.689Z",
    transform: "translate(-282.939 -329.435)",
    fill: "#ffde06"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M410.707,145.255l-3.472-.608-1.659,3.111-.494-3.482-3.482-.649,3.173-1.525-.484-3.5,2.462,2.524,3.163-1.535-1.659,3.121Z",
    transform: "translate(-361.156 -129.318)",
    fill: "#ffde06"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M403.072,279.787l1.071-3.348-2.843-2.091h3.533L405.915,271l1.1,3.348h3.533l-2.843,2.091,1.061,3.348-2.854-2.06Z",
    transform: "translate(-360.887 -248.079)",
    fill: "#ffde06"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M313.8,49.592l3.193,1.494L319.4,48.5l-.422,3.5,3.183,1.514-3.451.67-.433,3.5-1.72-3.08-3.461.639,2.4-2.575Z",
    transform: "translate(-281.773 -48.5)",
    fill: "#ffde06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.40b57d25af10edc2e698c4620a487aef.svg";
export { ForwardRef as ReactComponent };